/* eslint-disable no-param-reassign */
import { Store } from '@wonderlandlabs/looking-glass-engine';
import _ from 'lodash';
import { categoryFetchAll } from '../../../store/models/Category';
import { eventToString } from '../../../utils/eventExtraction';
import EllipsisTitle from "../../../views/EllipsisTitle";
import React from 'react';

function asNodes(children) {
  return _(children).map((child) => ({
    title: <EllipsisTitle text={child.categoryName} width={210} />,
    isLeaf: true,
    selectable: false,
    key: child.categoryName,
    link: true,
  }))
    .sortBy('title')
    .value();
}

export default (token) => {
  const catStore = new Store({
    state: {},
    actions: {
      chooseSearchString({ actions }, event) {
        actions.setSearchString(eventToString(event));
        actions.catToTree();
      },
      async reloadCategories({ state, actions }, event) {
        actions.setCatLoadError(null);
        actions.setCatLoaded(false);
        actions.setCatLoading(true);
        try {
          const categories = await categoryFetchAll(token);
          actions.setCatLoaded(true);
          actions.setCategories(categories);
          const tags = _(categories)
            .map('tags')
            .flatten()
            .compact()
            .uniq()
            .sortBy(_.identity)
            .value();

          actions.setTags(tags);
        } catch (err) {
          actions.setCatLoadError(err);
          actions.setCategories([]);
        }
        actions.setCatLoading(false);
        if (event) actions.setExpanded();
        actions.catToTree();
      },
      chooseTagFilter({ state, actions }, event) {
        const tag = eventToString(event);
        actions.setTagFilter(tag === ' ' ? '' : tag);
        actions.catToTree();
      },
      setExpanded({ state, actions }, event) {
        const { treeExpanded } = state;
        const expanded = event || ['root','categories','queries'];
        actions.setTreeExpanded(expanded);
        actions.catToTree();
      },
      catToTree({ state, actions }) {
        const { categories, searchString, tagFilter } = state;
        const ss = searchString ? searchString.toLowerCase() : '';
        const g = _(categories)
          .filter((cat) => {
            if ((tagFilter && tagFilter !== ' ') && !(_.get(cat, 'tags', []).includes(tagFilter))) {
              return false;
            }
            if (!ss) return true;
            if (cat.categoryName.toLowerCase().includes(ss)) return true;
            return false;
          })
          .groupBy(({ active }) => (active ? 'category' : 'query'))
          .value();

        const cats = _.get(g, 'category', []);
        const queries = _.get(g, 'query', []);
        const out = [
          {
            title: `Categories (${cats.length})`,
            key: 'categories',
            selectable: false,
            folder: true,
            children: asNodes(cats),
          },
          {
            title: `Queries (${queries.length})`,
            key: 'queries',
            selectable: false,
            folder: true,
            children: asNodes(_.get(g, 'query', [])),
          },
        ];

        actions.setCatTree(out);
      },
    },
  });

  catStore.addProp('categories', { type: 'array', start: [] })
    .addProp('searchString', { type: 'string', start: '' })
    .addProp('catTree', { type: 'array', start: [] })
    .addProp('tagFilter', { type: 'string', start: ' ' })
    .addProp('tags', { type: 'array', start: [] })
    .addProp('treeExpanded', { type: 'array', start: ['root', 'categories', 'queries'] })
    .addProp('activeTag', { type: 'string', start: '' })
    .addProp('catLoaded', { type: 'boolean', start: false })
    .addProp('catLoadError', { default: false })
    .addProp('catLoading', { type: 'boolean', start: true });

  catStore.start()
    .then(() => {
      catStore.actions.reloadCategories(true);
    });
  return catStore;
};
